export const ALERT_BAR_HEIGHT = 40;
export const NAVIGATION_BAR_HEIGHT = 40;
export const FLOATING_SIDEBAR_TOP_SPACING = 0;
export const FLOATING_SIDEBAR_BOTTOM_SPACING = 30;
export const POPOVER_SIDEBAR_WIDTH = 260;
